import { Grid, Typography, Box, Stack, TextField, MenuItem, Select, InputLabel, FormControl } from "@mui/material";
import { useForm } from "../../../../providers/FormProvider";
import { makeStyles } from "tss-react/mui";
import { useTranslation } from "react-i18next";
import { MissionEnums, MissionEnumsLists } from "../../../../common/constants";

const useStyles = makeStyles()(
  (theme) => ({
    root: {
      width: "100%"
    },
  })
);

export default function ExtraDetailsSection() {
  const { classes } = useStyles();
  const { t } = useTranslation();

  const {
    waitingAtLocation,
    setWaitingAtLocation,
    expectedDone,
    setExpectedDone,
    keyPlacement,
    setKeyPlacement,
    locked,
  } = useForm();

  return (
    <Stack className={classes.root} spacing={1}>

      <Typography variant="h6">
        {t("advancedForm:extraDetailsSection:title")}
      </Typography>

      <Box>
        <Grid container spacing={1} alignItems="space-between">

          <Grid item xs={12}>
            <FormControl fullWidth size="small" variant="filled">
              <InputLabel>{t("advancedForm:extraDetailsSection:waitingAtLocation")}</InputLabel>
              <Select onChange={ev => setWaitingAtLocation(ev.target.value)} value={waitingAtLocation === 0 ? "" : waitingAtLocation} disabled={locked}>
                {MissionEnumsLists.LocationState.map((type, value) => <MenuItem value={value} key={value}>{t(`enums:locationState:${type}`)}</MenuItem>)}
              </Select>
            </FormControl>
          </Grid>

          {
            waitingAtLocation === MissionEnums.LocationState.NoOneAtLocation ? (
              <Grid item xs={12}>
                <TextField
                  label={t("advancedForm:extraDetailsSection:keyPlacement")}
                  variant="filled"
                  value={keyPlacement}
                  onChange={ev => setKeyPlacement(ev.target.value)}
                  fullWidth
                  size="small"
                  disabled={locked}
                />
              </Grid>
            ) : null
          }

          <Grid item xs={12}>
            <TextField
              label={t("advancedForm:extraDetailsSection:expectedDone")}
              variant="filled"
              value={expectedDone}
              onChange={ev => setExpectedDone(ev.target.value)}
              fullWidth
              size="small"
              disabled={locked}
            />
          </Grid>

        </Grid>
      </Box>

    </Stack >
  );
}


